import React, { useContext } from 'react';
import { useDisclosure } from '@mantine/hooks';

export interface INavigationContext {
    opened: boolean;
    open: () => void;
    close: () => void;
}

export const navigationContext = React.createContext<INavigationContext>({
    opened: true,
    open: () => {},
    close: () => {},
});

type NavigationContextProviderProps = {
    children: React.ReactNode;
};

export const NavigationContextProvider: React.FC<NavigationContextProviderProps> = ({ children }) => {
    const [opened, { open, close }] = useDisclosure();

    const contextValue: INavigationContext = {
        opened,
        open,
        close,
    };

    return (
        <navigationContext.Provider value={contextValue}>
            {contextValue ? children : 'loading'}
        </navigationContext.Provider>
    );
};

export function useNavProvider() {
    const context = useContext(navigationContext);

    const { opened, open, close } = context;

    return {
        opened,
        open,
        close,
    };
}
